var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { shallowEqual, useSelector } from 'react-redux';
import ErrorMessage from '../../../../ui/atoms/ErrorMessage';
import determineCheckedAnswer from '../../../../helpers/determineCheckedAnswer';
import getCurrentQuestionAnswer from '../../../../helpers/getCurrentQuestionAnswer';
import AdditionalQuestionContent from '../../../../ui/molecules/AdditionalQuestionContent';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import { FIRST_QUESTION_ID, RECURRING_TABLE_LIST_QUESTION_ID } from '../../../../const/questionIds';
import { t } from '../../../../strings/i18n/i18n';
import DisputeLineItem from '../../../../ui/organisms/DisputeLineItem';
import { formatDisplayDateWithFormat } from 'syf-js-utilities';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { HeaderImageContainer, InputSection, LineItemContainer, QuestionHeader, QuestionHeaderSection, TransactionTitle } from './subcomponents';
import HelperText from '../HelperText';
import QuestionInput from '../QuestionInput';
import { getQuestionAnalytics } from './helpers';
var Question = function () {
    var _a, _b;
    var _c = useSelector(function (state) { return state; }, shallowEqual), accountId = _c.appConfig.accountId, assetsURL = _c.mfeConfig.assetsURL, _d = _c.questionnaire, currentQuestion = _d.currentQuestion, originalCaseSummary = _d.originalCaseSummary, duplicateTransactions = _d.duplicateTransactions, formError = _c.ui.formError, userAnswers = _c.userAnswers;
    var errorRef = useRef(null);
    var _e = useSelector(function (_a) {
        var transactionData = _a.transactionData;
        return transactionData;
    }, shallowEqual), merchantDesc = _e.merchantDesc, transactionAmount = _e.transactionAmount, transactionDate = _e.transactionDate;
    var lineItemDate = formatDisplayDateWithFormat(transactionDate, 'MMM d');
    var helperText = (_a = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionAlert) === null || _a === void 0 ? void 0 : _a.helperText;
    var alertType = (_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionAlert) === null || _b === void 0 ? void 0 : _b.alertType;
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var checkedAnswer = determineCheckedAnswer({
        currentQuestion: currentQuestion,
        currentQuestionAnswer: currentQuestionAnswer
    });
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    useEffect(function () {
        var hasDuplicateTransactions = !!(duplicateTransactions === null || duplicateTransactions === void 0 ? void 0 : duplicateTransactions.length);
        var questionAnalytics = getQuestionAnalytics(currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id, hasDuplicateTransactions);
        triggerAnalyticsEvent(questionAnalytics);
        // including hasDuplicateTransactions in the hook dependencies causes the analytics function to fire on selection/deselection inflating page views
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentQuestion]);
    useEffect(function () {
        if (!formError) {
            return;
        }
        var tableListAnalytics = {
            pageSubFunction: Analytics.RecurringCharge,
            pageName: Analytics.AdditionalTransactionsError,
            errorMessage: formError
        };
        var genericQuestionAnalytics = {
            pageSubFunction: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id,
            pageName: Analytics.QuestionnaireError
        };
        var analytics = (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id) === RECURRING_TABLE_LIST_QUESTION_ID
            ? tableListAnalytics
            : genericQuestionAnalytics;
        triggerAnalyticsEvent(__assign(__assign({}, analytics), { pageKind: Analytics.Dispute, pageFunction: Analytics.Billing }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formError]);
    useEffect(function () {
        var _a;
        if (!checkedAnswer && formError) {
            (_a = errorRef === null || errorRef === void 0 ? void 0 : errorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [checkedAnswer, formError]);
    return currentQuestion ? (_jsxs(_Fragment, { children: [_jsx(HeaderImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "DISPUTE_TRANSACTION", size: imageSize }) }), currentQuestion.id === FIRST_QUESTION_ID && (_jsx(TransactionTitle, __assign({ weight: "bold", as: "h2", id: "disputes-label", tabIndex: -1 }, { children: t('recognizeTransaction.transaction') }))), _jsx(LineItemContainer, { children: _jsx(DisputeLineItem, { amount: transactionAmount, postedDate: lineItemDate, merchantName: merchantDesc }) }), _jsxs("div", __assign({ "data-cy": "questionnaire-question" }, { children: [_jsxs(QuestionHeaderSection, { children: [!checkedAnswer && formError && (_jsx(ErrorMessage, { currentQuestion: currentQuestion, formError: formError, ref: errorRef })), _jsx(QuestionHeader, __assign({ as: "h2" }, { children: currentQuestion.questionText })), _jsx(HelperText, { accountId: accountId, alertType: alertType, disputeReason: originalCaseSummary === null || originalCaseSummary === void 0 ? void 0 : originalCaseSummary.disputeReason, helperText: helperText, questionId: currentQuestion.id })] }), _jsxs(InputSection, __assign({ "$questionId": currentQuestion.id }, { children: [_jsx(QuestionInput, { currentQuestion: currentQuestion }), _jsx(AdditionalQuestionContent, { currentQuestion: currentQuestion })] }))] }))] })) : null;
};
export default Question;
//# sourceMappingURL=index.js.map